import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { StoreUtils, StoreStatic, StateInput } from '@/store/storeUtils';
import posts from '@/store/modules/storePosts';
import { Category, ContactForm, System } from '@/models/dtos';
import { StoreObject, StoreObjectList } from '@/store/storeObject';
import { StoreModule } from '@/store/storeModule';
import { StateObject } from '@/store/stateObject';
import friggUtils from '@/utils/friggUtils';

Vue.use(Vuex);

export default new Vuex.Store({
	/**
	 * Store modules go here.
	 */
	modules: {
		posts,
	} as {[key: string]: StoreModule<any>},
	/**
	 * The state, these should only be used internally. Use getters for data access.
	 */
	state: {
		/**
		 * The system, set on load only.
		 */
		system: {
			dictionary: {} as  {[key: number]: StoreObject<System>},
			paramsDictionary: {} as  {[key: string]: StoreObjectList<System>},
		} as StateObject<System>,
	},
	mutations: {
		API_SYSTEM_PENDING(state) {
			StoreUtils.setPending<System>(state.system, new StateInput(null, -1));
		},
		API_SYSTEM_SUCCESS(state, system: any) {
			StoreStatic.systemData = system;
			StoreUtils.setSuccess<System>(state.system, system, new StateInput(null, -1));
		},
		API_SYSTEM_ERROR(state, error: any) {
			StoreUtils.setError<System>(state.system, error, new StateInput(null, -1));
		},
	},
	/**
	 * AJAX request that are sent to mutations
	 */
	actions: {
		/**
		 * Is run on startup only!
		 * Gets system and genrates router dynamically
		 * @returns {systemDto} System
		 */
		async loadSystem({commit, state}) {
			this.commit('API_SYSTEM_PENDING');
			try {
				const result = await axios.get(friggUtils.getUrl('/home/system'));
				this.commit('API_SYSTEM_SUCCESS', result.data);
				return result.data;
			} catch (error) {
				this.commit('API_SYSTEM_ERROR', error);
				throw error;
			}
		},
		/**
		 * Submits form data
		 */
		submitContactForm({commit, state}, {recaptchaToken, data}) {
			const params =  StoreUtils.getParams({recaptchaToken}, state);
			return axios.post(friggUtils.getUrl('/home/contactForms/submit'), data, {
				params,
			});
		},
		/**
		 * Validates the contact form, returns error if any.
		 */
		getContactFormErrors({commit, state}, data) {
			return axios.post(friggUtils.getUrl('/home/contactForms/validate'), data);
		},
	},
	/**
	 * The getters
	 */
	getters: {
		/**
		 * Gets contactForm for category
		 * The category is already loaded at init so no AJAX request is required.
		 */
		contactFormByCategoryId: (state) => (categoryId: number): ContactForm => {
			const systemStoreObject = state.system.dictionary[-1];
			if (systemStoreObject.data != null) {
				return getcontactFormByCategoryId(categoryId, systemStoreObject.data.categories);
			}
			throw notFoundError();

			function getcontactFormByCategoryId(cId: number, categories: Category[]): ContactForm {
				// tslint:disable-next-line
				for (const i in categories) {
					const category = categories[i];

					if (category.categoryId === cId) {
						return category.contactForm;
					}

					if (category.children.length > 0) {
						return getcontactFormByCategoryId(cId, category.children);
					}
				}
				throw notFoundError();
			}

			function notFoundError(): Error {
				// This should never happen, the category should always be found.
				return new Error('Category not found!');
			}
		},
	},
});



/**
 * Intercepts all http erros, and sends them to server
 */
axios.interceptors.response.use(undefined, (error) => {
	axios.post(friggUtils.getUrl('/home/error'), error);

	return Promise.reject(error);
});
